"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusText = void 0;
var _useTranslations = require("../i18n/useTranslations");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StatusText = _ref => {
  let {
    status
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, T.translate("issueStatus.".concat(status)));
};
exports.StatusText = StatusText;
//# sourceMappingURL=StatusText.js.map